import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import controlStrings from 'owa-strings/owa-common-strings';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import QuickOptionSearchEntry from './QuickOptionSearchEntry';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import onQuickOptionToggle from 'owa-options-actions/lib/onQuickOptionToggle';
var styles = require('./QuickOptions.scss');
var QuickOptionEntry = /** @class */ (function (_super) {
    tslib_1.__extends(QuickOptionEntry, _super);
    function QuickOptionEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onToggle = function (isToggledOn) {
            onQuickOptionToggle(isToggledOn, _this.props.option);
        };
        return _this;
    }
    QuickOptionEntry.prototype.render = function () {
        var option = this.props.option;
        var quickOptionSettings = option.quickOptionSettings, key = option.key;
        if (!quickOptionSettings) {
            // No render was provided. Instead, render as link to full options
            return React.createElement(QuickOptionSearchEntry, tslib_1.__assign({}, this.props));
        }
        var optionAriaId = "options-quick-" + key;
        var optionTooltipId = optionAriaId + "-tooltip";
        var rendering = quickOptionSettings.rendering, tooltip = quickOptionSettings.tooltip, customTitle = quickOptionSettings.customTitle;
        var _a = tooltip || {}, tooltipStringKey = _a.tooltipStringKey, shouldHideTooltip = _a.shouldHideTooltip;
        var render = rendering.render;
        var _b = rendering, isToggleOn = _b.isToggleOn, onToggle = _b.onToggle, hideToggle = _b.hideToggle, isDisabled = _b.isDisabled;
        if (typeof tooltipStringKey === 'function') {
            tooltipStringKey = tooltipStringKey();
        }
        return (React.createElement("div", { className: styles.quickSetting },
            React.createElement("div", { id: optionAriaId, className: styles.quickSettingHeader, role: "heading", "aria-level": 3 },
                React.createElement("div", { className: styles.title },
                    React.createElement("span", null, strings[customTitle || option.titleStringKey]),
                    tooltip &&
                        (!shouldHideTooltip || !shouldHideTooltip()) && (React.createElement(TooltipHost, { content: strings[tooltipStringKey], id: optionTooltipId },
                        React.createElement(Icon, { iconName: "Info" /* Info */, className: styles.infoIcon })))),
                isToggleOn &&
                    onToggle &&
                    (!hideToggle || !hideToggle()) && (React.createElement(Toggle, { checked: isToggleOn(), onChanged: this.onToggle, className: styles.toggle, disabled: isDisabled && isDisabled(), onAriaLabel: controlStrings.toggle_on, offAriaLabel: controlStrings.toggle_off }))),
            render &&
                render({
                    headerAriaId: optionAriaId,
                })));
    };
    QuickOptionEntry = tslib_1.__decorate([
        observer
    ], QuickOptionEntry);
    return QuickOptionEntry;
}(React.Component));
export default QuickOptionEntry;
//# sourceMappingURL=QuickOptionEntry.js.map